import React from 'react';
import { SettingsTabPanel } from '@/components/molecules/SettingsTabPanel';
import { Container } from '@/components/organisms/Container';
import { Header } from '@/components/molecules/Header';
import { FloatingActionButton } from '@/components/atoms/FloatingActionButton';
import { BackToTopButton } from '@/components/atoms/BackToTopButton';
import { useDefaultLayoutStyles } from '@/static/stylesheets/layouts';
import { FeatureType } from '@/types';

interface TasksLayoutProps {
  children?: React.ReactNode;
  hideSettingsTabPanel?: boolean;
  hideHeaderRightSide?: boolean;
  hideHeaderProfile?: boolean;
  containerSize?: any;
  featureType?: FeatureType;

  onChangeType?(): void;
}

const TasksLayout: React.FC<TasksLayoutProps> = (props) => {
  const classes = useDefaultLayoutStyles();
  const { onChangeType } = props;

  const scrollTop = () => {
    const body = document.querySelector('.block-item');
    if (body != null) {
      body.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Header
          hideHeaderRightSide={props.hideHeaderRightSide}
          hideHeaderProfile={props.hideHeaderProfile}
          onChangeLeadType={onChangeType}
          featureType={props?.featureType}
        />
        {props.children}
      </div>

      <FloatingActionButton />
      <BackToTopButton scrollTop={scrollTop} />
    </>
  );
};

export { TasksLayout };
